import axios from 'axios';
import { useQuery } from 'react-query';
import { KA_API_URL } from '../../config/baseUrl';

export const GET_PERFORMANCE_SETTINGS = `${KA_API_URL}/config/performance_settings`;

/**
 * Requests
 */

const fetchPerformanceSettings = async () => axios.get(GET_PERFORMANCE_SETTINGS);

/**
 * Hooks
 */

const PERFORMANCE_SETTINGS_QUERY_KEY_BASE = 'performanceSettings';

export const usePerformanceSettings = queryConfig =>
  useQuery(
    [PERFORMANCE_SETTINGS_QUERY_KEY_BASE],
    async () => {
      const response = await fetchPerformanceSettings();

      return response?.data ?? [];
    },
    queryConfig,
  );
